import axios from 'axios';
import { AdresseIP } from './AdresseIp';

export class LitService {

    constructor(){
        this.adresse = new AdresseIP()
    }
    
    getAll() {
        
        return axios.get(this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/lit')
                    .then(res => res.data);
    }
    create(newLit) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/lit'
        return axios.post(url,newLit)
                    .then(res => res.data);
    }
    update(idLit ,newLit) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/lit/'
        return axios.put(url+idLit, newLit)
                    .then(res => res.data);
    }
    delete(idLit) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/lit/'
        return axios.patch(url+idLit)
                    .then(res => res.data)
    }
    get(idChambre) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/lit/?idChambre='+idChambre
        return axios.get(url)
                    .then(res => res.data)
    }

}